import { useNavigation } from '@refinedev/core'
import { useParams } from 'react-router'
import { ResourceForm } from '@/components/shared/ResourceForm'
import { Button } from '@/components/ui/button'
import { toTitleCase } from '@/lib/utils'
import { ArrowLeft } from 'lucide-react'

export function EditPage({ resource }: { resource: string }) {
  const { goBack } = useNavigation()
  const { id } = useParams<{ id: string }>()

  if (!id) {
    return (
      <div className="space-y-4">
        <p className="text-sm text-destructive">Missing record id in URL.</p>
        <Button variant="outline" size="sm" onClick={() => goBack()}>
          Go back
        </Button>
      </div>
    )
  }

  return (
    <div className="space-y-5">
      <div className="flex items-center gap-3">
        <Button variant="ghost" size="icon" className="shrink-0" onClick={() => goBack()}>
          <ArrowLeft size={16} />
        </Button>
        <h1 className="min-w-0 text-lg sm:text-xl font-semibold tracking-tight break-words">Edit {toTitleCase(resource)}</h1>
      </div>
      <ResourceForm resource={resource} action="edit" recordId={id} />
    </div>
  )
}
